import { ApiClientAxios } from "@repo/api";
import { readEnv } from "@repo/helpers";
import axios from "axios";
import { msalInstance, msalReady } from "./msalInstance";

const configurationParameters: ApiClientAxios.ConfigurationParameters = {
    async accessToken() {
        // Wait for MSAL to be initialized before attempting token acquisition
        await msalReady;

        const tokenResponse = (
            await msalInstance.acquireTokenSilent({
                scopes: ["openid", readEnv("VITE_B2C_API_SCOPE") ?? ""],
            })
        ).accessToken;
        return `${tokenResponse}`;
    },
    basePath: readEnv("VITE_API_BASE_URL"),
};

const axiosInstance = axios.create();

export type ApiFactoryConfigTuple = [
    ApiClientAxios.Configuration | undefined,
    string | undefined,
    typeof axiosInstance | undefined,
];

export const apiFactoryConfig: ApiFactoryConfigTuple = [
    new ApiClientAxios.Configuration(configurationParameters),
    readEnv("VITE_API_BASE_URL"),
    axiosInstance,
];
